var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3 w-8rem",class:{ 'd-none': _vm.item.displayOn && !_vm.display_none_check}},[_c('Label',{attrs:{"item":_vm.item}}),_c('img',{staticClass:"image-icon my-2",attrs:{"src":_vm.getImgUrl(_vm.item.source)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }